import gql from 'graphql-tag';

export default gql`
  mutation DeleteAppValuationReport($accountId: ID!, $id: ID!) {
    deleteAppValuationReport(accountId: $accountId, id: $id) {
      __typename
    }
  }
`;
